import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Lock, User, Sparkles } from "lucide-react";
import apiClient from "../../business/network/ApiClient";
import { ASKMILA_PATH } from "../shell/agentRegistry";
import greenRoadLogo from "../../images/greenroad-logo.svg";

const CustomAlert = ({ children }) => (
  <div
    className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
    role="alert"
  >
    <span className="block sm:inline">{children}</span>
  </div>
);

const LoginPage = ({ onLogin }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [credentials, setCredentials] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      var token = await apiClient.login(
        credentials.username,
        credentials.password
      );

      if (token) {
        localStorage.setItem("Token", JSON.stringify(token));
        onLogin();
        // Back to whatever the sign-in interrupted — the agent they had bookmarked, say —
        // rather than to the chat regardless. `replace`, so Back does not return to a login
        // form that is already satisfied.
        navigate(location.state?.from || ASKMILA_PATH, { replace: true });
      } else {
        setError("Invalid username or password");
      }
    } catch (err) {
      setError("Invalid username or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ backgroundColor: "#243f63" }}
    >
      <div className="bg-white rounded-lg shadow-xl w-96 p-8 transform transition-all">
        <div className="mb-8 text-center relative">
          <img src={greenRoadLogo} alt="GreenRoad" className="mx-auto h-10 w-auto" />
          <br />
          <h1
            className="text-5xl font-bold tracking-wider"
            style={{ color: "#243f63" }}
          >
            Mila AI
          </h1>
          <div className="absolute -top-4 -right-4">
            <div className="animate-spin-slow">
              <Sparkles className="text-blue-500" size={24} />
            </div>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          {error && <CustomAlert>{error}</CustomAlert>}

          <div className="relative">
            <User
              className="absolute left-3 top-1/2 transform -translate-y-1/2 fill-gray-400"
              size={26}
            />
            <input
              type="text"
              placeholder="Username"
              className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500 text-2xl"
              value={credentials.username}
              onChange={(e) =>
                setCredentials({ ...credentials, username: e.target.value })
              }
              required
            />
          </div>

          <div className="relative">
            <Lock
              className="absolute left-3 top-1/2 transform -translate-y-1/2 fill-gray-400"
              size={26}
            />
            <input
              type="password"
              placeholder="Password"
              className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:border-blue-500  text-2xl"
              value={credentials.password}
              onChange={(e) =>
                setCredentials({ ...credentials, password: e.target.value })
              }
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{ backgroundColor: "#243f63" }}
            className={`w-full text-white py-2 rounded-lg transform transition-all 
                ${loading ? "opacity-70" : "hover:bg-blue-800"}`}
          >
            {loading ? "Connecting..." : "Connect"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
